import { render } from "./Thing.vue?vue&type=template&id=5c7ec87e&scoped=true&lang=pug"
import script from "./Thing.vue?vue&type=script&lang=js"
export * from "./Thing.vue?vue&type=script&lang=js"

import "./Thing.vue?vue&type=style&index=0&id=5c7ec87e&scoped=true&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7ec87e"]])

export default __exports__